.wrapper {
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;
  }

  .grid-view {
    min-height: 100%;
    align-items: stretch;
  }
}
